import Vue from 'vue'

// Lib imports
import axios from 'axios'

Vue.prototype.$http = axios



// WEBPACK FOOTER //
// ./VueSrc/Common/Components/materialcomponents/plugins/axios.js